<template lang="pug">
    article.techs(:class='{hidden: !swiperLoaded, "techs--swiper-mode": isSwiperOn}')

        Preloader(:class='{hide: swiperLoaded}')

        .swiper-container(ref='swiperContainer')
            .swiper-wrapper

                //- .swiper-slide(v-if='!isMobile()')

                section.swiper-slide.tech(
                    v-for='({name, title, heading, infograph, id, subassets, indicator, index, subIndex, sub, category, categoryname, theme, themecolor, logo, description, descriptions, counters, countersTrigger} = asset, blockIndex) in techs',
                    :data-index='index',
                    :data-subindex='subIndex',
                    :data-sub='sub',
                    :data-id='id',
                    :data-infograph='infograph',
                    :data-category='category',
                    :style='`--block-theme: ${theme};`',
                    ref='slide'
                    )

                    .tech__backimage(v-if='!countersTrigger && !isMobile() && !themecolor', :data-background='require(`@/assets/img/technologies/${id}.jpg`)')
                        .swiper-lazy-preloader

                    lazy-background(v-if='countersTrigger && isMobile() && !themecolor', :src='require(`@/assets/img/technologies/${id}.jpg`)', position='50% 50%', size='cover', repeat='no-repeat')

                    .tech__nav
                        .tech__label {{categoryname}}

                    .tech__heading(v-observe-visibility='visibilityChanged', :class='{info: countersTrigger}')
                        h1.h1.tech__logo.tech__logo--text.tech__logo--text-center(v-if='!logo && title') {{title}}
                        h1.h1.tech__logo.tech__logo--text(v-if='!logo && !title') {{name}}
                        .tech__logo.tech__logo--pic(v-if='logo && id')
                            img(:src='"@/assets/img/logo/" + id + ".svg"', :alt='name')

                    p.tech__subheader(v-if='heading && !countersTrigger', v-observe-visibility='visibilityChanged') {{heading}}

                    p.tech__description(v-if='description && !countersTrigger', v-html='description', v-observe-visibility='visibilityChanged')

                    .tech__descriptions(v-if='descriptions && !countersTrigger', v-observe-visibility='visibilityChanged')
                        .tech__descriptions-block(v-for='desc in descriptions') {{desc}}

                    .tech__counters-block(v-if='counters && countersTrigger', v-for='count in counters', :class='{single: counters.length < 2 && !indicator}', v-observe-visibility='visibilityChanged')

                        //- .tech__counter-heading(v-if='count.heading') {{count.heading}}

                        .tech__counters.counters(v-if='(counters && countersTrigger) || sub', v-observe-visibility='visibilityChanged')

                            .tech__pusher(v-if='count.points.length < 3')
                            .tech__counter(v-for='({number, description, addtext, info, showInfo} = counter, counterIndex) in count.points', :class='{adtext: addtext}')

                                .tech__counter-number {{number}}

                                .tech__counter-add-text(v-if='addtext', v-html='addtext')

                                .tech__counter-description(@click='() => {if (info) openInfo(blockIndex, counterIndex)}', :class='{clickable: info}')
                                    span(v-html='description')
                                    br
                                    //- span.tech__counter-popup(:class='{show: info && showInfo}') {{info}}
                                    span.tech__counter-popup.show {{info}}
                            .tech__pusher(v-if='count.points.length < 3')

                    .tech__indicator(v-if='countersTrigger && indicator', :class='{single: counters}', v-observe-visibility='visibilityChanged')
                        .tech__indicator-heading(v-if='indicator.heading', v-html='indicator.heading')
                        .tech__indicator-text(v-html='indicator.text')

                .swiper-slide(v-if='!isMobile()')

        .techs-arrow-selector
            .techs-arrow-selector__arrow.techs-arrow-selector__arrow--prev(@click='changeAsset("prev")')
                svg(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 306 306', width='306', height='306')
                    path(d='M94.35 0l-35.7 35.7L175.95 153 58.65 270.3l35.7 35.7 153-153z')
                .show-asset.show-asset--prev
                    span {{showAsset.prev}}

            .techs-arrow-selector__arrow.techs-arrow-selector__arrow--next(@click='changeAsset("next")')
                svg(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 306 306', width='306', height='306')
                    path(d='M94.35 0l-35.7 35.7L175.95 153 58.65 270.3l35.7 35.7 153-153z')
                .show-asset.show-asset--next
                    span {{showAsset.next}}

        .techs__arrow-scroll
            svg(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 306 306', width='306', height='306')
                    path(d='M94.35 0l-35.7 35.7L175.95 153 58.65 270.3l35.7 35.7 153-153z')

        Footer.techs__footer
</template>

<script>
import Preloader from '../components/Preloader.vue';
import Footer from '../components/Footer.vue';
import technologiesData from '../assets/data/technologies.json';
import Swiper, {Mousewheel, EffectFade, Lazy} from 'swiper';
Swiper.use([Mousewheel, EffectFade, Lazy]);
// import {TweenMax, Power2} from 'gsap';
// import assetsData from '../assets/data/assets.json';

export default {
    name: 'Technologies',

    props: {
        category: {
            required: false,
            type: String
        },
        id: {
            required: false,
            type: String
        }
    },

    components: {
        Preloader,
        Footer
    },

    data() {
        return {
            swiper: null,
            currentTransitionSpeed: 0,
            techs: [],
            swiperLoaded: false,
            isSwiperOn: false
        };
    },

    computed: {
        showAsset() {
            let newNextPrev = {
                next: '',
                prev: ''
            };
            if (this.swiperLoaded && !this.isMobile) {
                let currentAssetIndex = this.swiper.slides[this.swiper.activeIndex].dataset.index
                    ? this.swiper.slides[this.swiper.activeIndex].dataset.index
                    : this.swiper.slides[this.swiper.activeIndex - 1].dataset.index;
                newNextPrev.next = this.swiper.realIndex < this.techs.length - 1 ? this.techs[this.getNextAssetIndex(currentAssetIndex, 'next')].name : '';
                newNextPrev.prev = this.swiper.realIndex > 0 ? this.techs[this.getNextAssetIndex(currentAssetIndex, 'prev')].name : '';
            }
            return newNextPrev;
        }
    },

    watch: {
        $route(to) {
            this.goToSlide(to.params.category, to.params.id);
        }
    },

    beforeMount() {
        const assetsArray = [];

        let sortedAssetData = this.sortAssetsArray(technologiesData.technologies);

        sortedAssetData.forEach((asset, index) => {
            let assetCopy = {...asset};
            asset.index = index;
            asset.sub = false;
            assetsArray.push(asset);

            // проверяем наличие второй страницы с инфографикой
            if (asset.counters || asset.indicator) {
                assetCopy.countersTrigger = true;
                assetCopy.infograph = true;
                assetsArray.push(assetCopy);
            }

            if (asset.subassets) {
                asset.subassets.forEach((subasset, subIndex) => {
                    subasset.sub = true;
                    subasset.index = index;
                    subasset.subIndex = subIndex;
                    assetsArray.push(subasset);
                });
            }
        });

        this.techs = assetsArray;

        this.checkProps();
    },

    mounted() {
        this.$store.dispatch('setTheme', 'white');
        if (!this.isMobile()) {
            this.initSw();
            this.isSwiperOn = true;
        } else {
            this.isSwiperOn = false;
            this.swiperLoaded = true;
            this.goToSlide(this.category, this.id);
        }

        window.addEventListener('keyup', this.arrowEvent);
    },

    beforeDestroy() {
        if (this.swiper) {
            this.isSwiperOn = false;
            this.swiper.destroy();
        }
        window.removeEventListener('keyup', this.arrowEvent);
    },

    methods: {
        arrowEvent(e) {
            if (e.key === 'ArrowRight') {
                this.changeAsset('prev');
            } else if (e.key === 'ArrowLeft') {
                this.changeAsset('next');
            }
        },

        initSw() {
            let initialSlide = this.techs.findIndex(asset => {
                if (asset.category === this.category && asset.id === this.id) return true;
            });
            if (initialSlide < 0) initialSlide = 0;

            const that = this;
            this.swiper = new Swiper(this.$refs.swiperContainer, {
                direction: 'vertical',
                mousewheel: {
                    eventsTarged: this.$refs.swiperContainer
                },
                speed: 1300,
                initialSlide,
                watchSlidesProgress: true,
                virtualTranslate: true,
                effect: 'fade',
                simulateTouch: false,
                keyboard: true,
                lazy: {
                    loadPrevNext: true,
                    elementClass: 'tech__backimage'
                },
                on: {
                    init() {
                        const swiper = this;
                        that.setActiveThemeColor(swiper);
                        that.setRouterPath(swiper);
                        swiper.allowSlideNext = false;
                        setTimeout(() => {
                            swiper.allowSlideNext = true;
                        }, 1000);
                        that.swiperLoaded = true;
                    },
                    reachEnd() {
                        setTimeout(() => {
                            that.goNextArticle();
                        }, 1000);
                    }
                },
                breakpoints: {
                    480: {
                        direction: 'horizontal'
                    }
                }
            });

            this.swiper.on('slideChange', () => {
                this.setActiveThemeColor(this.swiper);
                this.setRouterPath(this.swiper);
            });
        },

        checkIfNextSlideIsSubcategory(curIndex) {
            if (this.$refs.slide[curIndex + 1].dataset.sub) {
                return true;
            } else {
                return false;
            }
        },

        changeAsset(direction) {
            if ((this.swiper.isBeginning && direction === 'prev') || (this.swiper.isEnd && direction === 'next')) return;

            let currentAssetIndex = this.swiper.slides[this.swiper.activeIndex].dataset.index
                ? this.swiper.slides[this.swiper.activeIndex].dataset.index
                : this.swiper.slides[this.swiper.activeIndex - 1].dataset.index;

            if (currentAssetIndex === 0 && direction === 'prev') return;
            if (currentAssetIndex === technologiesData.technologies && direction === 'next') return;
            let nextAssetIndex = this.getNextAssetIndex(currentAssetIndex, direction);
            this.swiper.slideTo(nextAssetIndex);
        },

        getNextAssetIndex(currentAssetIndex, direction) {
            let targetAssetIndex = direction === 'prev' ? Number(currentAssetIndex) - 1 : Number(currentAssetIndex) + 1;
            let resultSlideIndex = 0;

            this.$refs.slide.forEach((slide, index) => {
                if (!slide.dataset.sub && slide.dataset.infograph !== 'true') {
                    if (Number(slide.dataset.index) === targetAssetIndex) {
                        resultSlideIndex = index;
                    }
                }
            });
            return resultSlideIndex;
        },

        setActiveThemeColor(swiper) {
            swiper;
            // if (this.techs[swiper.realIndex].theme) document.documentElement.style.setProperty('--color-theme', this.techs[swiper.realIndex].theme);
        },

        setRouterPath(swiper) {
            if (swiper.realIndex !== this.techs.length) {
                const actualRouteParams = {
                    name: this.$route.name,
                    params: {
                        id: this.$route.params.id,
                        category: this.$route.params.category
                    }
                };

                const newRouteParams = {
                    name: 'technologies',
                    params: {
                        id: this.techs[swiper.realIndex].id,
                        category: this.techs[swiper.realIndex].category
                    }
                };

                // не меняем роутинг если слайд в предыдущем роуте
                if (actualRouteParams.params.id === newRouteParams.params.id && actualRouteParams.params.category === newRouteParams.params.category) return;
                this.$router.push(newRouteParams).catch(() => {});
            }
        },

        openInfo(blockIndex, counterIndex) {
            this.techs[blockIndex].counters[counterIndex].showInfo = !this.techs[blockIndex].counters[counterIndex].showInfo;
        },

        checkProps() {
            if (!this.category) {
                if (this.swiper && this.swiper.realIndex !== this.techs.length) {
                    this.$router.push({path: `/technologies/${this.techs[0].category}/${this.techs[0].id}`}).catch(() => {});
                }
            } else if (!this.id) {
                let firstElementInCategory = this.techs.findIndex(asset => {
                    if (asset.category === this.category) return true;
                });

                if (firstElementInCategory < 0) firstElementInCategory = 0;

                if (this.swiper.realIndex !== this.techs.length) {
                    this.$router
                        .push({path: `/technologies/${this.techs[firstElementInCategory].category}/${this.techs[firstElementInCategory].id}`})
                        .catch(() => {});
                }
            }
        },

        goToSlide(category, id) {
            if (this.isMobile()) {
                this.scrollToSlide(id);
                return;
            }
            if (this.techs[this.swiper.realIndex].category === category && this.techs[this.swiper.realIndex].id === id) return;
            let matchedSlide = this.techs.findIndex(asset => {
                if (asset.category === category && asset.id === id) return true;
            });
            if (matchedSlide < 0) matchedSlide = 1;
            this.swiper.slideTo(matchedSlide);
        },

        scrollToSlide(id) {
            let element = this.$refs.slide.find(el => el.dataset.id === id);

            this.$nextTick(() => {
                element.scrollIntoView();
            });
        },

        sortAssetsArray(arr) {
            let servicesCategories = ['atech', 'bigdata', 'product', 'okkotech', 'infrastructuresolutions'];
            let categoriesArrays = [];

            servicesCategories.forEach((serviceCategory, index) => {
                categoriesArrays[index] = arr.filter(item => item.category === serviceCategory);
                categoriesArrays[index].sort((a, b) => {
                    const la = a.name.toLowerCase().charCodeAt(0);
                    const lb = b.name.toLowerCase().charCodeAt(0);
                    const nameA = a.name.toLowerCase(),
                        nameB = b.name.toLowerCase();

                    if (la > 1071 && lb > 1071) {
                        return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
                    }
                    if (la > 1071 || lb > 1071) {
                        return nameA > nameB ? -1 : nameA > nameB ? 1 : 0;
                    } else {
                        return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
                    }
                });
            });

            let sortedAssetData = categoriesArrays[0].concat(categoriesArrays[1], categoriesArrays[2], categoriesArrays[3], categoriesArrays[4]);

            return sortedAssetData;
        },

        goNextArticle() {
            this.$router.push({name: 'clients'}).catch(() => {});
        },

        goPrevArticle() {
            this.$router.push({path: '/assets/infrastructure/rco'}).catch(() => {});
        },

        isMobile() {
            return typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
        },

        visibilityChanged(e, el) {
            if (e) {
                el.target.classList.add('show-mobile');
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';
@import '../assets/css/base.scss';

:root {
    --block-theme: #232222;
    --color-theme: #232222;
    --vh: 5.68px;
}

// .techs {
//     opacity: 1;
//     transition: opacity 0.4s ease 0.5s;

//     &.hidden {
//         opacity: 0;

//         @media (--viewport-tablet) {
//             opacity: 1;
//         }
//     }
// }

.techs {
    &__footer {
        position: relative;
        z-index: 5;

        .techs--swiper-mode & {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 5;
        }
    }

    &__arrow-scroll {
        position: absolute;
        width: 100%;
        height: 0.6em;
        bottom: #{2.2em + 0.2em + 2.86em};
        z-index: 3;
        pointer-events: none;
        text-align: center;
        animation: arrow 1.5s infinite;

        svg {
            width: 30px;
            height: auto;
            fill: white;
            transform: rotate(90deg);
        }

        @media (--viewport-tablet) {
            display: none;
        }
    }

    @keyframes arrow {
        0% {
            opacity: 0;
            transform: translateY(-1em);
        }
        75% {
            opacity: 1;
            transform: translateY(1em);
        }
        90% {
            opacity: 0;
            transform: translateY(1em);
        }
        100% {
            opacity: 0;
            transform: translateY(1em);
        }
    }
}

.swiper {
    &-container {
        width: 100%;
        height: 100vh;
        perspective: 800px;
        background-color: #232222;

        @media (--viewport-tablet) {
            height: auto;
        }
    }

    &-wrapper {
        transform-style: preserve-3d;
        overflow: hidden;

        @media (--viewport-tablet) {
            overflow: auto;
            display: block;
        }
    }

    &-slide {
        width: 100%;
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        pointer-events: none;
        color: white;
        background: var(--block-theme);
        transition: background 0.3s ease 0.3s;

        @media (--viewport-tablet) {
            pointer-events: all;
            -webkit-overflow-scrolling: touch;
            height: auto;
            min-height: 100vh;
            padding-bottom: 5vh;
        }

        &-active {
            pointer-events: all;
        }

        // &[data-infograph='true'] {
        //     padding-top: calc(1.4em + 25vh);
        //     box-sizing: border-box;

        //     @media (--viewport-tablet) {
        //         padding-top: calc(1.4em + 6vh);
        //     }
        // }
    }
}

.tech {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow-y: auto;
    justify-content: flex-start;

    @media (--viewport-tablet) {
        -webkit-overflow-scrolling: touch;
        overflow-y: auto;
        justify-content: center;
    }

    &__indicator {
        // padding-top: calc(1.4em + 12vh);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;

        &.single {
            padding-top: 10px;

            .tech__indicator-heading {
                padding-top: 20px;
            }

            .tech__indicator-text {
                padding-top: 20px;
            }
        }

        &-text {
            max-width: calc((var(--layout-column-width) * 6) + (var(--layout-gutter-width) * 5));
            padding-top: calc(1.4em + 15vh);
            padding-top: 20px;
            text-align: justify;

            @media (--viewport-laptop-l) {
                max-width: calc((var(--layout-column-width) * 8) + (var(--layout-gutter-width) * 7));
            }

            @media (--viewport-tablet) {
                max-width: calc((var(--layout-column-width) * 10) + (var(--layout-gutter-width) * 10));
            }
        }

        &-heading {
            text-align: center;
        }
    }

    &__nav {
        position: absolute;
        top: 20vh;
        left: 0;
        width: 100%;
        z-index: 2;

        @supports (--css: variables) {
            top: calc(var(--vh) * 20);
        }

        @media (--viewport-tablet) {
            top: 5em;
        }
    }

    &__label {
        box-sizing: border-box;
        margin: 0 auto;
        text-transform: uppercase;
        opacity: 0.5;
        font-family: var(--font-accent);
        margin-bottom: 1em;
        text-align: center;
    }

    &__heading,
    &__subheader,
    &__description,
    &__descriptions,
    &__counters,
    &__indicator,
    &__counters-block {
        opacity: 0;
        transition: opacity 0.1s ease, transform 0.3s ease-out 0.5s;
        transform: translateY(20px);
        z-index: 1;

        @media (--viewport-tablet) {
            transition: opacity 0.5s ease 0.5s, transform 0.5s ease-out 0.5s;
        }

        &.show-mobile {
            @media (--viewport-tablet) {
                transform: translateY(0px);
                opacity: 1;
            }
        }
    }

    &__heading {
        position: relative;
        z-index: 1;
        font-size: 2em;
        text-transform: uppercase;
        padding-top: calc(1.4em + 21vh);

        padding-left: 8vw;
        padding-right: 8vw;

        &.info {
            transform: translateY(0px);
            opacity: 1;

            @media (--viewport-tablet) {
                opacity: 0;
                transform: translateY(20px);
            }

            &.show-mobile {
                @media (--viewport-tablet) {
                    transform: translateY(0px);
                    opacity: 1;
                }
            }
        }

        @media (--viewport-laptop-l) {
            max-width: calc((var(--layout-column-width) * 8) + (var(--layout-gutter-width) * 7));
        }

        @media (--viewport-tablet) {
            max-width: calc((var(--layout-column-width) * 10) + (var(--layout-gutter-width) * 10));
            margin-top: 2em;
            padding-top: 20vh;
            text-align: center;
        }
    }

    &__counter-heading,
    &__indicator-heading {
        font-size: 1.2em;
        text-transform: uppercase;
        // padding-top: calc(1.4em + 5vh);

        @media (--viewport-laptop-l) {
            max-width: calc((var(--layout-column-width) * 8) + (var(--layout-gutter-width) * 7));
            // margin-top: 2em;
        }

        @media (--viewport-tablet) {
            max-width: calc((var(--layout-column-width) * 10) + (var(--layout-gutter-width) * 10));
            // margin-top: 2em;
            // padding-top: calc(1.4em + 5vh);
            text-align: center;
        }
    }

    &__logo {
        &--text {
            min-height: calc(100vw * 195 / 1920);

            @media (--viewport-tablet) {
                min-height: calc(100vw * 95 / 320);
            }
        }

        &--text-center {
            text-align: center;
        }

        &--pic {
            width: calc(var(--layout-column-width) * 4 + var(--layout-gutter-width) * 3);

            @media (--viewport-tablet) {
                width: calc(var(--layout-column-width) * 10 + var(--layout-gutter-width) * 10);
            }

            img {
                width: 100%;
            }
        }
    }

    &__backimage {
        position: fixed;
        top: 0;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center center;

        &:before {
            content: '';
            display: inline-block;
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.6);
        }
    }

    .lazy-background {
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;

        &:before {
            position: relative;
            z-index: 2;
            content: '';
            display: inline-block;
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.6);
        }
    }

    &__subheader {
        font-size: 1.2em;
        line-height: 1.4;
        text-align: center;
        text-transform: uppercase;
        max-width: calc((var(--layout-column-width) * 6) + (var(--layout-gutter-width) * 5));
        margin-bottom: 1em;

        @media (--viewport-laptop-l) {
            max-width: calc((var(--layout-column-width) * 8) + (var(--layout-gutter-width) * 7));
        }

        @media (--viewport-tablet) {
            max-width: calc((var(--layout-column-width) * 10) + (var(--layout-gutter-width) * 10));
            margin-top: 2em;
            text-align: center;
        }
    }

    &__descriptions {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        @media (--viewport-tablet) {
            flex-direction: column;
        }

        &-block {
            width: calc((var(--layout-column-width) * 2) + (var(--layout-gutter-width) * 1));
            margin: 0 calc(var(--layout-gutter-width) / 2);
            text-align: center;

            @media (--viewport-laptop-l) {
                width: calc((var(--layout-column-width) * 3) + (var(--layout-gutter-width) * 2));
            }

            @media (--viewport-tablet) {
                width: 100%;
                margin: 0;
                padding: 0 calc((var(--layout-column-width) * 1) + (var(--layout-gutter-width) * 1));
            }
        }
    }

    &__description {
        font-size: 1em;
        line-height: 1.4;
        text-align: justify;
        max-width: calc((var(--layout-column-width) * 6) + (var(--layout-gutter-width) * 5));
        // margin-top: 4em;

        @media (--viewport-laptop-l) {
            max-width: calc((var(--layout-column-width) * 8) + (var(--layout-gutter-width) * 7));
            margin-top: 0em;
        }

        @media (--viewport-tablet) {
            max-width: calc((var(--layout-column-width) * 10) + (var(--layout-gutter-width) * 10));
            margin-top: 2em;
            text-align: center;
        }
    }

    &-popup {
        font-size: 0.8em;
    }

    &__indicator-block {
        position: relative;
        z-index: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    &__counters-block {
        position: relative;
        z-index: 1;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        &.single {
            .counters {
                padding-top: calc(1.4em + 11vh);
                padding-top: 0;
                margin-top: 0;

                .tech__counter-heading {
                    padding-top: 0;
                }
            }

            @media (--viewport-tablet) {
                margin: 0 !important;
                padding: 0 !important;
            }
        }

        &:nth-of-type(2) {
            // padding-top: calc(1.4em + 12vh);
            // padding-top: 20px;

            @media (--viewport-tablet) {
                margin-top: 2em;
                padding-top: calc(1.4em + 5vh);
            }
        }

        &:nth-of-type(3) {
            padding-top: 0px;
            margin: 0 !important;

            .tech__counter-heading {
                margin: 0 !important;
                padding-top: 20px;
            }

            @media (--viewport-tablet) {
                // padding-top: 20vh;
                margin: 0 !important;

                .tech__counter-heading {
                    margin: 0 !important;
                    padding-top: 10vh;
                }
            }

            .counters {
                margin-top: 0;
            }
        }

        &:nth-child(4) {
            padding-top: 30px;
            margin: 0 !important;

            .tech__counter-heading {
                margin: 0 !important;
                padding-top: 20px;
            }

            @media (--viewport-tablet) {
                padding-top: 30px;
                margin: 0 !important;

                .tech__counter-heading {
                    margin: 0 !important;
                    padding-top: 20px;
                }
            }
        }

        @media (--viewport-tablet) {
            max-width: calc((var(--layout-column-width) * 10) + (var(--layout-gutter-width) * 10));
        }
    }

    &__counters {
        position: relative;
        z-index: 1;
        width: 100%;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
        grid-template-rows: 1fr;
        grid-column-gap: 20px;
        margin-top: 3em;
        padding: 0 8vw;
        box-sizing: border-box;

        @media (--viewport-laptop-l) {
            margin-top: 2em;
        }

        @media (--viewport-tablet) {
            display: block;
            padding: 0;
            padding-bottom: 8vh;
            margin-top: 1em;
        }
    }

    &__counter {
        text-align: center;
        padding: 10px 0;

        &.adtext {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-template-rows: auto 1fr;
            grid-column-gap: 10px;
            align-items: end;
            grid-template-areas: 'number adtext' 'desc desc';

            .tech__counter {
                &-number {
                    text-align: right;
                }

                &-add-text {
                    text-align: left;
                }
            }
        }

        &-number {
            font-size: 3em;
            line-height: 1;
            grid-area: number;
            line-height: 0.7;

            @media (--viewport-laptop-l) {
                font-size: 2em;
            }
        }

        &-add-text {
            font-size: 0.9em;
            grid-area: adtext;
            line-height: 1;
        }

        &-description {
            display: inline-block;
            font-size: 0.9em;
            max-width: 25vw;
            align-self: stretch;
            justify-self: center;
            grid-area: desc;
            padding-top: 10px;

            @media (--viewport-laptop-l) {
                font-size: 0.8em;
            }

            @media (--viewport-tablet) {
                max-width: unset;
            }

            &.clickable {
                // cursor: pointer;
            }
        }

        &-popup {
            opacity: 0;
            font-size: 0.7em;
            transition: opacity 0.3s ease;

            &.show {
                opacity: 1;
            }
        }
    }

    &.swiper-slide-active {
        .tech {
            &__heading,
            &__subheader,
            &__description,
            &__descriptions,
            &__counter-heading,
            &__counters,
            &__indicator,
            &__counters-block {
                opacity: 1;
                transform: translateY(0px);
                z-index: 1;
            }

            &__heading,
            &__counter-heading,
            &__indicator-heading {
                transition: opacity 0.3s ease 0.3s, transform 0.3s ease-out 0.3s;
            }

            &__heading {
                &.info {
                    transition: none;
                }
            }

            &__subheader {
                transition: opacity 0.3s ease 0.4s, transform 0.3s ease-out 0.4s;
            }

            &__description,
            &__descriptions {
                transition: opacity 0.3s ease 0.4s, transform 0.3s ease-out 0.4s;
            }

            &__counters,
            &__counters-block {
                transition: opacity 0.3s ease 0.5s, transform 0.3s ease-out 0.5s;
            }
        }
    }

    &.swiper-slide-prev {
        .tech {
            &__heading {
                opacity: 1;
                transform: translateY(0);
                transition: none;
            }
        }
    }
}

.swiper-lazy-preloader {
    display: none;
}

.techs-arrow-selector {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 5;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 5vw;
    pointer-events: none;

    @media (--viewport-tablet) {
        display: none;
        align-items: flex-start;
        height: 15vw;
        top: 100%;
        top: calc(var(--vh) * 100);
        transform: translateY(-100%);
        padding: 0 5vw;
    }

    &__arrow {
        cursor: pointer;
        font-size: 2em;
        color: white;
        pointer-events: auto;

        svg {
            width: 30px;
            height: auto;
            fill: white;
        }

        &--prev {
            svg {
                transform: rotate(180deg);
            }
        }

        @media (--viewport-tablet) {
            width: 10vw;
            height: 10vw;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;

            svg {
                position: relative;
                z-index: 2;
                width: 5vw;
                height: auto;
            }

            &:before {
                content: '';
                position: absolute;
                display: inline-block;
                width: 100%;
                height: 100%;
                background: var(--color-theme);
                border-radius: 10vw;
                transition: background-color 0.5s ease 0.4s;
            }
        }

        .show-asset {
            position: absolute;
            font-size: 14px;
            height: 100%;
            top: 0;
            display: flex;
            pointer-events: none;
            transition: opacity 0.4s ease;
            opacity: 0;

            span {
                margin: auto;
            }

            &--next {
                transform: translateX(-110%);
            }

            &--prev {
                transform: translateX(60px);
            }
        }

        @media not all and (hover: none) {
            &:hover {
                .show-asset {
                    opacity: 1;
                }
            }
        }
    }
}

.home {
    font-family: var(--font-main);

    @media (--viewport-tablet) {
        background: red;
    }

    &__img {
        border: 1px dashed;
    }
}
</style>
